/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { MetricsResponse } from './metricsResponse';

export type GenericApiResponseMetricsResponseData = MetricsResponse | null;
